import { render } from "./ui-input.vue?vue&type=template&id=3e988d60&scoped=true&ts=true"
import script from "./ui-input.vue?vue&type=script&lang=ts"
export * from "./ui-input.vue?vue&type=script&lang=ts"

import "./ui-input.vue?vue&type=style&index=0&id=3e988d60&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e988d60"]])

export default __exports__